<template>
  <section class="search">
    <router-link class="searchInput" to="/mobile/product/search">
      <p>搜索您需要的机型</p>
      <van-icon name="search" size="24px" color="#888" class="search-icon"/>
  </router-link>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.searchInput {
  width: 3.475rem;
  height: 0.32rem;
  line-height: 0.32rem;
  padding-left:0.125rem;
  margin:0 auto;
  box-shadow:0px 0px 0.04rem 0px rgba(134,130,130,0.3);
  border-radius:0.04rem;
  display: block;
  position: relative;
}
.search-icon{
    position: absolute;
    top:0.05rem;
    right:0.02rem;
}
</style>
